module.exports = __webpack_public_path__ + "static/media/rounded-yellow-warning.c25c35c1.svg";